import Emitter from "es6-event-emitter";
import {
  CLICKED_BACK_ERRORPOPUP,
  CLICKED_CLOSE_ERRORPOPUP,
  CLOSED_ERRORPOPUP,
  OPENED_ERRORPOPUP,
} from "./../../common/analytics/analyticsevents";

import { isAuthenticationAuthorizationError } from "../utilities/errors/authenticationAuthorizationError";
import {
  disableAllScrolling,
  enableAllScrolling,
} from "./../../common/utilities/utils";
import language from "./../dictionary";
import errorPopup from "./../templates/errorPopup.dust";
// eslint-disable-next-line
import topNavigationOverlay from "./../templates/topNavigationOverlay.dust"; // this is needed!
export default class ErrorPopup extends Emitter {
  appState = null;
  DOMContainer = null;
  options = null;

  publicationData = null;

  disabledScrolling = [];

  constructor(appState, DOMContainer, options = null) {
    super();
    this.appState = appState;
    this.DOMContainer = DOMContainer;
    this.options = options;
    this.render();
  }

  render() {
    if (this.DOMContainer !== null) {
      //create context
      const context = {};
      context.close = true;
      context.back = true;
      context.language = language;
      Dust.render(errorPopup, context, (err, result) => {
        this.DOMContainer.innerHTML = result;
        this.attachClickHandlers();
      });
    }
  }

  attachClickHandlers() {
    if (this.DOMContainer !== null) {
      $(this.DOMContainer).on("click", (e) => {
        if (e.target === this.DOMContainer) {
          e.preventDefault();
          this.hide();
          this.trigger("errorPopup:close");
        }
      });
      $(this.DOMContainer).on("click", ".overlay-navigation-close", () => {
        this.onClose();
      });
      $(this.DOMContainer).on("click", "#btn_close", () => {
        this.onClose();
      });
      $(this.DOMContainer).on("click", "#top-navigation-overlay-back", () => {
        this.onBack();
      });
    }
  }

  onClose() {
    this.hide();
    this.appState.triggerEvent(CLICKED_CLOSE_ERRORPOPUP);
    this.trigger("errorPopup:close");
  }

  onBack() {
    this.hide();
    this.appState.triggerEvent(CLICKED_BACK_ERRORPOPUP);
    this.trigger("errorPopup:back");
  }

  hide() {
    if (this.DOMContainer) {
      this.DOMContainer.classList.add("hidden");
    }
    enableAllScrolling(this.disabledScrolling);

    this.appState.triggerEvent(CLOSED_ERRORPOPUP);
  }

  removeBackButtonAndShowTitle() {
    if (this.DOMContainer) {
      const popupBackButton = this.DOMContainer.querySelector(
        "#top-navigation-overlay-back"
      );
      const titleContainer = this.DOMContainer.querySelector(
        "#top-navigation-overlay-title"
      );

      if (popupBackButton) {
        popupBackButton.classList.add("hidden");
      }
      if (titleContainer) {
        titleContainer.innerHTML = language.Sorry;
        this.DOMContainer.classList.add("showOverlay");
        titleContainer.classList.remove("hidden");
      }
    }
  }

  showError(message) {
    if (this.DOMContainer) {
      const errorContainer = this.DOMContainer.querySelector(".error-message");
      if (errorContainer) {
        errorContainer.innerHTML = message;
        errorContainer.classList.remove("hidden");
      }
    }
  }

  show(error) {
    if (!error) {
      return;
    }
    if (this.DOMContainer) {
      let message = "";
      this.removeBackButtonAndShowTitle();
      if (isAuthenticationAuthorizationError(error)) {
        message = error.message;
      }

      this.DOMContainer.classList.remove("hidden");
      this.disabledScrolling = disableAllScrolling();
      this.appState.triggerEvent(OPENED_ERRORPOPUP);

      this.showError(message);
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/errorPopup.js